module Meevo.Plugins.DrawerManager {
    "use strict";

    export class CashCalculatorSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        public denominations: Meevo.Model.DenominationAmount[] = null;
        public focusedDenomination: Meevo.Model.DenominationAmount;
        private prevAmount: number;
        private isSaved = false;
        private dateFilter;
        public isPrinting: boolean = false;
        public decimalPositions: number = 0;

        constructor(drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected printService: Meevo.Components.Common.IPrintService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected $filter: angular.IFilterService,
            personalHeader: boolean,
            personalFooter: boolean,
            protected identityService: Meevo.Components.Common.IIdentityService) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.CashCalculator, drawerManagerContext, "cashCalculator", personalHeader, personalFooter);
            this.dateFilter = $filter('meevoDateTimeFilter');
        }

        reset() {
            super.reset();
            this.denominations = [];
            this.focusedDenomination = null;
            this.prevAmount = 0;

            this.decimalPositions = this.identityService.current().decimalPositions;
            this.context.getMoneyDenomination().then((denominations) => {
                denominations.forEach((item) => {
                    this.setDecimalPositions(item);
                    this.denominations.push(_.clone(item));
                });
            });
        }

        setDecimalPositions(item) {
            if (item.moneyAmount >= 1) {
                return;
            }

            const decimalPositions = this.extractNumberOfDecimalPostions(item);

            if (decimalPositions == -1) {
                return;
            }
            
            if (decimalPositions > this.decimalPositions) {
                this.decimalPositions = decimalPositions;
            }
        }

        extractNumberOfDecimalPostions(item) {
            const moneyAmount = item.moneyAmount.toString();
            const decimalIndex = moneyAmount.indexOf('.');
            if (decimalIndex == -1) {
                return -1;
            }
            return moneyAmount.substring(decimalIndex + 1).length;
        }

        print() {
            if (!this.isSaved) {
                this.modalService.confirm("MESSAGE_CASH_CALCULATOR_PRINT").then((result) => {
                    if (result) {
                        this.saveAndClose(true);
                    }
                });
            } else {
                const receiptUrl: string = "/api/Drawer/" + this.context.selectedDrawer.id + "/CashCount/";
                this.isPrinting = true;

                let drawerStateLabel = "";
                if (this.context.isOpeningClosingDrawer) {
                    let tempLabel = (this.context.selectedDrawer.drawerSession.drawerState === Model.DrawerStateEnum.Close) ? "LABEL_DRAWER_OPENING" : "LABEL_DRAWER_CLOSING";
                    drawerStateLabel = this.$translate.instant(tempLabel) + " " + this.$translate.instant("LABEL_CASH_IN_DRAWER");
                }
                else {
                    let dateUpdated = _.chain(this.context.selectedDrawer.drawerSession.drawerSessionHistory)
                        .where({ drawerState: this.context.selectedDrawer.drawerSession.drawerState })
                        .sortBy(function (sessionHistory) { return sessionHistory.dateUpdated; })
                        .first()  //possible multiple updates to the session after closing or opening, so we want date when session was Open/Closed at first
                        .value();
                    let tempLabel = this.context.selectedDrawer.drawerSession.drawerState === Model.DrawerStateEnum.Close ? "LABEL_CLOSED_ON" : "LABEL_OPENED_ON";
                    drawerStateLabel = this.$translate.instant(tempLabel) + ' ' + this.dateFilter(dateUpdated.dateUpdated);
                }

                const activeDenominations = this.denominations.filter(denomintion => !this.isDenominationDisabled(denomintion));

                //TODO: this.context.selectedPrinter must match the one selected in the print service
                const request = { 
                    url: receiptUrl, 
                    method: "POST", 
                    data: { 
                        denominations: activeDenominations,
                        locale: this.appSettings.APP_COUNTRYID,
                        timeFormat: this.appSettings.APP_TIME_FORMAT,
                        drawerLabel: drawerStateLabel,
                        drawerName: this.context.selectedDrawer.displayName
                    } 
                };
                this.printService.printCustom(request)
                    .then(() => {
                        this.context.closeSection();
                        // extract all Payment Transaction items and pass it back to the Context
                        this.context.setCalculatedCashTotal(this.getTotalCash(), this.denominations);
                    }).finally(() => this.isPrinting = false);
                    
                this.isSaved = false;
            }
        }
        
        saveAndClose(doPrint = false) {
            this.isSaved = true;
            if (doPrint) {
                this.print();
            } else {
                this.context.closeSection();

                // extract all Payment Transaction items and pass it back to the Context
                this.context.setCalculatedCashTotal(this.getTotalCash(), this.denominations);
            }
        }

        close() {
            this.context.closeSection();
        }

        clearFocusedItem() {
            this.focusedDenomination = null;
        }

        focusedOn(item: Meevo.Model.DenominationAmount, index) {
            this.focusedDenomination = item;
            this.prevAmount = this.focusedDenomination.amount;
        }

        updateAmount(item: Meevo.Model.DenominationAmount, index) {
            this.focusedDenomination = item;
            this.focusedDenomination.amount = Number(item.quantity || 0) * (item.moneyAmount);
        }

        inputNumber(value) {
            if (this.focusedDenomination) {
                this.focusedDenomination.quantity = (Number(this.focusedDenomination.quantity || 0) * 10) + value;
                this.focusedDenomination.amount = Number(this.focusedDenomination.quantity) * this.focusedDenomination.moneyAmount;
                this.setFocusOnAmount(this.focusedDenomination.moneyAmount);
            }
        }

        addRoll(item) {
            this.focusedDenomination = item;
            this.focusedDenomination.quantity = Number(this.focusedDenomination.quantity || 0) + item.bundleQuantity;
            this.setFocusOnAmount(this.focusedDenomination.moneyAmount);
        }

        clearInput() {
            if (this.focusedDenomination) {
                this.focusedDenomination.quantity = 0;
            }
        }

        setFocusOnAmount(amt) {
            this.$timeout(() => {
                let elem = $("input[name='dmccInput" + amt + "']");
                elem.focus();
            }, 0);
        }

        finishInput(item?: Meevo.Model.DenominationAmount, index?: number, event?: JQueryEventObject) {
            if (item) {
                var inputs = $(":tabbable");
                var index = _.indexOf(inputs, event.target);
                if (index >= 0 && index < inputs.length - 1) {
                    inputs[index + 1].focus();
                }
            }
            else if (this.focusedDenomination) {
                index = this.denominations.indexOf(this.focusedDenomination);
                if (this.denominations.length - 1 > index) {
                    this.setFocusOnAmount(this.denominations[index + 1].moneyAmount);
                }
                else {
                    let elem = $("#dmccPrint");
                    if (elem) {
                        elem.focus();
                    }
                }
            }
        }

        getTotalCash() {
            let totalCash = 0;
            this.denominations.forEach((item) => {
                 totalCash += item.amount || 0;
            });
            return this.context.normalizeDecimalPlaces(totalCash);
        }

        isDenominationDisabled(item: Meevo.Model.DenominationAmount) {
            const identity = this.identityService.current();
            const decimalPositions = identity.decimalPositions;

            return this.extractNumberOfDecimalPostions(item) > decimalPositions;
        }
    }
}